import fleetApi from "@/lib/fleetApi";
import { dayKey } from "@/lib/time";

const norm = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");
const MATCH_MIN = 15;

// For each day in the file: trips already on that day that aren't in the file, and file rows that
// repeat a trip already there (same rider, pickup within 15 min) — usually a standing order added nightly.
export async function checkImportDays(fileTrips) {
  const days = [...new Set(fileTrips.map((t) => dayKey(t.scheduled_pickup)).filter(Boolean))].sort();
  return Promise.all(days.map(async (day) => {
    const mine = fileTrips.filter((t) => dayKey(t.scheduled_pickup) === day);
    const ids = new Set(mine.map((t) => t.external_trip_id).filter(Boolean));
    let existing = [];
    try { existing = (await fleetApi.get(`/trips?date=${day}&limit=5000`)).data || []; } catch { return { day, unknown: true, existing: 0, dupes: [] }; }
    const others = existing.filter((t) => !ids.has(t.external_trip_id));
    const dupes = mine.filter((f) => others.some((t) => norm(t.rider_name) === norm(f.rider_name)
      && Math.abs(new Date(t.scheduled_pickup) - new Date(f.scheduled_pickup)) <= MATCH_MIN * 60000)).map((f) => f.external_trip_id).filter(Boolean);
    return { day, existing: others.length, standing: others.filter((t) => t.auto_standing || t.is_standing).length, dupes };
  }));
}

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
export const dropRows = (csv, extIds) => {
  if (!extIds.length) return csv;
  const res = extIds.map((id) => new RegExp(`(^|,)\\s*"?${esc(id)}"?\\s*(,|$)`));
  return csv.split(/\r?\n/).filter((line) => !res.some((r) => r.test(line))).join("\n");
};
